import endpoints from "../utils/endpoints";
import { message } from "antd";
import { Api } from "./api";
import { notificationError, notificationSucces } from "./notification";
import { removeEmpty } from "../utils/objectUtils";
import { exportCsv } from "../utils/fileUtils";
import { DateFormatEnum } from "../enums/dateFormatEnum";
import dayjs from "dayjs";

export async function getAllTags(){
    let res = {
      tags: []
    }
    await Api.get(endpoints.getAllTags).then((response) => {
      if(response.status === 200 && response.data) {
        if(response.data.error) {
          notificationError(`${response.data.message}`)
        } else {
          res = response.data
        }
      }
    }).catch((err: string) => {
      notificationError('Could not get data from servers')
    })
    
    return res
}

export async function getDeviceTags(deviceList: never[]){
  let res = {
    tags: [],
  }
  let params = {
    deviceList: deviceList.map((device: any) => device.id).join()
  }
  await Api.post(endpoints.getDeviceTags, {params}).then((response) => {
    if(response.status === 200 && response.data) {
      if(response.data.error) {
        notificationError(`${response.data.message}`)
      } else {
        res = response.data
      }
    }
  }).catch((err: string) => {
    notificationError('Could not get data from servers')
  })

  return res
}

export async function addTag(nameParam: string){
  let res = {
    tags: []
  }
  let params = {
    name: nameParam
  }

  await Api.get(endpoints.addTag, {params}).then((response) => {
    if(response.status === 200 && response.data) {
      if(response.data.error) {
        notificationError(`${response.data.message}`)
      } else {
        res = response.data
      }
    }
  }).catch((err: string) => {
    notificationError('Could not get data from servers')
  })

  return res
}

export async function addTagToDevices(tagParam: string, deviceList: never[]){
  console.log('In addTagToDevices' + JSON.stringify(deviceList))
  let res = {
    tags: []
  }
  let params = {
    tagId: tagParam,
    deviceList: deviceList.map((device: any) => device.id).join()

  }
  let params2 = {
    deviceList: deviceList.map((device: any) => device.id).join()
  }

  console.log(JSON.stringify(params))
  console.log(JSON.stringify(params2))
  await Api.post(endpoints.addTagToDevices, {params}).then((response) => {
    if(response.status === 200 && response.data) {
      if(response.data.error) {
        notificationError(`${response.data.message}`)
      } else {
        res = response.data
      }
    }
  }).catch((err: string) => {
    notificationError('Could not get data from servers')
  })

  return res
}

export async function removeTagFromDevices(tagParam: string, deviceList: never[]){
  console.log('In removeTagFromDevices' + JSON.stringify(deviceList))
  let res = {
    tags: []
  }
  let params = {
    tagId: tagParam,
    deviceList: deviceList.map((device: any) => device.id).join()
  }
  await Api.post(endpoints.removeTagFromDevices, {params}).then((response) => {
    if(response.status === 200 && response.data) {
      if(response.data.error) {
        notificationError(`${response.data.message}`)
      } else {
        res = response.data
      }
    }
  }).catch((err: string) => {
    notificationError('Could not get data from servers')
  })

  return res
}

export async function deleteTag(tagParam: string){
  let res = {
    tags: []
  }
  let params = {
    tagId: tagParam
  }

  await Api.get(endpoints.deleteTag, {params}).then((response) => {
    if(response.status === 200 && response.data) {
      if(response.data.error) {
        notificationError(`${response.data.message}`)
      } else {
        res = response.data
      }
    }
  }).catch((err: string) => {
    notificationError('Could not get data from servers')
  })

  return res
}

